import React, { useState, useContext } from 'react';

import styles from './PageHeader.module.css';

import { logoff} from '../ServerCalls/serverCalls.js';
import {SocketContext} from 'Contexts/SocketContext.js';
import {QuoteMasterContext} from 'Contexts/QuoteMasterContext.js';

import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem'; 
import Typography from '@mui/material/Typography';

export default function PageHeader({setIsUserAdminPanelOpen, setIsProvidersPanelOpen, setIsRunningServiceOrdersPanelOpen, setIsWAErrorReportOpen}) { 
    const {user, setUser, setCurrentServiceOrder, setServiceOrders, freshServiceOrder} = useContext(QuoteMasterContext);
    const {socketShouldReconnect} = useContext(SocketContext);
    const [anchorElUser, setAnchorElUser] = useState(null);
    
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };
    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };


    const regularUserSettings = ['Logout', 'OpenProvidersPanel', 'RunningServiceOrders', 'WAErrorLogReportButton'];
    const masterAdminSettings = ['Logout', 'OpenUserAdminPanel', 'OpenProvidersPanel', 'RunningServiceOrders', 'WAErrorLogReportButton'];
    const settings = user.userType === 'master-admin' ? masterAdminSettings : regularUserSettings;
    
    const regularUserSettingsLabels = {
        Logout: 'Logout',
        OpenProvidersPanel: 'Painel de Afiliados',
        RunningServiceOrders: 'Ordens de Serviço em Andamento',
        WAErrorLogReportButton: 'Erros WA - Relatório',
    };
    const masterAdminSettingsLabels = {
        Logout: 'Logout',
        OpenUserAdminPanel: 'Painel de Usuários',
        OpenProvidersPanel: 'Painel de Afiliados',
        RunningServiceOrders: 'Ordens de Serviço em Andamento',
        WAErrorLogReportButton: 'Erros WA - Relatório',
    };
    const settingsLabels = user.userType === 'master-admin' ? masterAdminSettingsLabels : regularUserSettingsLabels;


    const regularUserHandlers = {
        Logout: handleLogout,
        OpenProvidersPanel: handleOpenProvidersPanel,
        RunningServiceOrders: handleRunningServiceOrders,
        WAErrorLogReportButton: handleWAErrorLogReportButton,
    };   

    const masterAdminHandlers = {
        Logout: handleLogout,
        OpenUserAdminPanel: handleOpenUserAdminPanel,
        OpenProvidersPanel: handleOpenProvidersPanel,
        RunningServiceOrders: handleRunningServiceOrders,
        WAErrorLogReportButton: handleWAErrorLogReportButton,
    }; 

    const settingsHandlers = user.userType === 'master-admin' ? masterAdminHandlers : regularUserHandlers;
  
    async function handleLogout(){
        try{
            socketShouldReconnect.current = false;
            await logoff();
            localStorage.removeItem('quoteMasterUser');
            setUser({});
            setCurrentServiceOrder(freshServiceOrder);
            setServiceOrders([]);
            setIsUserAdminPanelOpen(false);
            setIsProvidersPanelOpen(false);
            setIsRunningServiceOrdersPanelOpen(false);
            setWAErrorReportPanel(false);
        } catch(error){
            console.error("Error during logoff", error);
        }
    }

    function handleOpenUserAdminPanel(){
        setIsUserAdminPanelOpen(true);
    }

    function handleOpenProvidersPanel(){
        setIsProvidersPanelOpen(true);
    }

    function handleRunningServiceOrders(){
        setIsRunningServiceOrdersPanelOpen(true);
    }

    function handleWAErrorLogReportButton(){
        setIsWAErrorReportOpen(true);
    }

    return(
        <div className={styles.pageHeader}>
            <div className={styles.pageHeaderTitle}>{`Olá ${user.firstName}!`}</div>
            <Tooltip title={user.userEmail} placement="bottom">
                <Avatar
                    alt={user.userEmail} 
                    src={user.profilePic} 
                    className={styles.avatar}  
                    style={{width: '40px', height: '40px'}}
                    onClick={handleOpenUserMenu}
                />
            </Tooltip>
            <Menu
                sx={{mt: '35px'}}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
            >
                {settings.map((setting) => (
                    <MenuItem key={setting} onClick={() => {handleCloseUserMenu();  settingsHandlers[setting]()}} sx={{height: 35}} >
                        <Typography textAlign="center" sx={{fontSize: 16}}>{settingsLabels[setting]}</Typography>
                    </MenuItem>
                ))}
            </Menu>
        </div>
    )

}

